/* Progressive inline validation. Valid forms retain Shopify's native submission and spam protection. */
(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('form.lr-form:not([data-lr-validation])').forEach(form => {
      form.dataset.lrValidation = 'true';
      form.noValidate = true;
      const fields = [...form.querySelectorAll('input:not([type="hidden"]), select, textarea')];
      const validate = field => {
        const error = document.getElementById(`${field.id}-error`);
        if (!error) return field.checkValidity();
        let message = '';
        if (field.validity.valueMissing) message = field.type === 'checkbox' ? 'Bitte bestätige die Datenschutzeinwilligung.' : 'Bitte fülle dieses Pflichtfeld aus.';
        else if (field.validity.typeMismatch && field.type === 'email') message = 'Bitte gib eine gültige E-Mail-Adresse ein.';
        else if (field.validity.rangeUnderflow || field.validity.stepMismatch || field.validity.badInput) message = 'Bitte gib eine ganze Zahl ab 1 ein.';
        else if (!field.validity.valid) message = 'Bitte prüfe deine Eingabe.';
        error.textContent = message;
        field.setAttribute('aria-invalid', message ? 'true' : 'false');
        const describedBy = new Set((field.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
        describedBy.add(error.id);
        field.setAttribute('aria-describedby', [...describedBy].join(' '));
        return !message;
      };
      fields.forEach(field => {
        field.addEventListener('blur', () => validate(field));
        field.addEventListener('input', () => { if (field.getAttribute('aria-invalid') === 'true') validate(field); });
        field.addEventListener('change', () => validate(field));
      });
      form.addEventListener('submit', event => {
        const invalid = fields.filter(field => !validate(field));
        if (invalid.length) { event.preventDefault(); invalid[0].focus(); }
      });
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('click', event => {
    if (!event.target.closest('.lr-cookie-open')) return;
    const banner = document.querySelector('.popup--cookies');
    if (banner && typeof banner.show === 'function') {
      banner.o.enabled = true;
      banner.show();
      banner.querySelector('button')?.focus();
    }
  });
})();
